// App
import type React from 'react';
import { useMemo } from 'react';

import { PriceMyRentalSearchModule } from '@zg-rentals/zrm-marketing-components';

import { getCanAccessCookieValue } from '../../utils/cookieUtils';

import FeatureFlagConstants from '../../constants/FeatureFlagConstants';

// Components
import SearchModule from '../../modules/SearchModule';

// Misc / utils
import HeroImageWebp from 'images/priceMyRentalHero.webp';
import * as S from './styles';

const SearchHeroModule = () => {
  const canAccessZRMMarketingComponents = useMemo(
    () => getCanAccessCookieValue(FeatureFlagConstants.ZRM_MARKETING_COMPONENTS_ENABLED),
    [],
  );

  const styles = {
    // Simulate overlay on background. Inline styles prevents re-downloading of images
    heroStyles: {
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(${HeroImageWebp})`,
    } as React.CSSProperties,
  };

  return (
    <S.SearchHeroModule style={styles.heroStyles}>
      <S.SearchHeroModuleContent>
        <S.HeroHeading fontColor="textWhite" fontFamily="serif" level="1" fontType="h3" marginBottom="sm">
          Price your rental - Start here
        </S.HeroHeading>

        {canAccessZRMMarketingComponents ? <PriceMyRentalSearchModule /> : <SearchModule />}
      </S.SearchHeroModuleContent>
    </S.SearchHeroModule>
  );
};

export default SearchHeroModule;
